"use client";

import { c as _c } from "react/compiler-runtime";
import { IconInfoCircle, IconMessageCircle } from "@tabler/icons-react";
import Link from "next/link";
import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { trackSearchNoResults, trackSearchNoResultsLinkClicked } from "@/lib/analytics/segment";
import { scrubQueryClient } from "@/lib/search/clientPiiScrub";
import { useSearchPanelStore } from "@/stores/useSearchPanelStore";
interface Props {
  query: string;
}
export function SearchNoResults(t0) {
  const $ = _c(24);
  const {
    query
  } = t0;
  const close = useSearchPanelStore(_temp);
  const trackedQueryRef = useRef(null);
  let t1;
  if ($[0] !== query) {
    t1 = scrubQueryClient(query);
    $[0] = query;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const safe = t1;
  let t2;
  let t3;
  if ($[2] !== safe) {
    t2 = () => {
      if (trackedQueryRef.current === safe) {
        return;
      }
      trackedQueryRef.current = safe;
      trackSearchNoResults({
        query: safe
      });
    };
    t3 = [safe];
    $[2] = safe;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col gap-3"><h2 className="text-2xl font-bold leading-8 text-foreground">Didn't find what you were looking for?</h2><p className="text-base font-semibold text-foreground">Try different search keywords.</p></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== close || $[7] !== safe) {
    t5 = () => {
      trackSearchNoResultsLinkClicked({
        target: "product-request",
        query: safe
      });
      close();
    };
    $[6] = close;
    $[7] = safe;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `/product-requests?q=${encodeURIComponent(safe)}`;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconInfoCircle />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6) {
    t8 = <Link href={t6}>{t7}Request A Product</Link>;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = <Button asChild={true} variant="ghost" onClick={t5}>{t8}</Button>;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== close || $[16] !== safe) {
    t10 = () => {
      trackSearchNoResultsLinkClicked({
        target: "contact-support",
        query: safe
      });
      close();
    };
    $[15] = close;
    $[16] = safe;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Link href="/contact-us"><IconMessageCircle />Contact Support</Link>;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10) {
    t12 = <Button asChild={true} variant="ghost" onClick={t10}>{t11}</Button>;
    $[19] = t10;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t9) {
    t13 = <div className="flex flex-col items-center justify-center gap-7 pt-12 pb-6 text-center" data-testid="search-no-results">{t4}<div className="flex w-full flex-col items-center justify-center gap-3 md:flex-row md:gap-6">{t9}{t12}</div></div>;
    $[21] = t12;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
}
function _temp(state) {
  return state.close;
}